/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1462
 */

module.exports = {
  MODE_NUMBER: 1,
  MODE_ALPHA_NUM: 2,
  MODE_8BIT_BYTE: 4,
  MODE_KANJI: 8
}
